import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ['actionclick']

  connect() {
    const options = {
      theme: ['tooltipster-light', 'tooltipster-light-customized',],
      interactive: true,
      contentAsHTML: true,
      maxWidth: 300,
      updateAnimation: null
    }

    if (this.hasActionclickTarget) {
      options.trigger = 'click'
    }

    if (this.data.has('customClass')) {
      options.theme.push(this.data.get('customClass'))
    }

    if (this.data.has('trigger')) {
      options.trigger = this.data.get('trigger')
    }

    if (this.data.has('minWidth')) {
      options.minWidth = this.data.get('minWidth')
    }

    if (this.data.has('maxWidth')) {
      options.maxWidth = this.data.get('maxWidth')
    }

    if (this.data.has('async')) {
      options.functionBefore = (instance, helper) => {
        if (this.data.get('loaded') === 'true') return;
        instance.content('<div class="tw-flex tw-justify-center tw-items-center" style="width: 266px; height: 220px"><i class="tw-mx-auto fa fa-spinner fa-spin"></i></div>');
        $.ajax({
          type: 'GET',
          url: this.data.get('asyncPath'),
          success: (data) => {
            instance.content(data);
            this.data.set('loaded', true);
          },
          error: (error) => {
            console.error(error);
            instance.content('Erro ao carregar o conteúdo');
            typeof Bugsnag !== "undefined" && Bugsnag.notify(error);
          }
        })
      }
    }

    $(this.element).tooltipster(options)
  }
}
